<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'changeTrains',
  data() {
    return {};
  },
  components: {},
  created() {
    if (this.$route.query && this.$route.query.path) {
      this.$router.push({
        name: this.$route.query.path,
      });
    }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent');
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
